import React from 'react'

import {
  UnderlineCalloutHeader,
  UnderlineArticleHeader,
  UnderlineText,
} from 'components/UnderlineText'
import { getPlainTextFromReactNode } from 'utils/react'

import { TitleResolver } from '../types'
import ContentfulTooltip from '../reference-blocks/contentful-tooltip'
import ContentfulAsset from '../reference-blocks/contentful-asset'
import ContentfulArbitraryEmbeddedCode from '../reference-blocks/contentful-arbitrary-embedded-code'
import ContentfulRecipe from '../reference-blocks/contentful-recipe'
import ContentfulWorkout from '../reference-blocks/contentful-workout'
import ContentfulDownloadCta from '../reference-blocks/contentful-download-cta'
import ContentfulSignupCta from '../reference-blocks/contentful-signup-cta'

import generateRTFComponent from '.'

const resolveTitle: TitleResolver = (children, level) => {
  const title = getPlainTextFromReactNode(children).replace(/\n/g, '')

  if (!title) return null
  switch (level - 1) {
    case 2:
      return <UnderlineCalloutHeader text={title} />
    case 3:
      return <UnderlineArticleHeader text={title} />
    default:
      return <UnderlineText text={title} />
  }
}

const PCMPageRTF = generateRTFComponent(
  {
    ContentfulTooltip,
    ContentfulAsset,
    ContentfulArbitraryEmbeddedCode,
    ContentfulRecipe,
    ContentfulWorkout,
    ContentfulDownloadCta,
    ContentfulSignupCta,
  },
  resolveTitle
)

export default PCMPageRTF
